import { productRepository } from '../services/productRepository';
import type { Category } from '../types';

/**
 * Drop-in replacement for the reference UI's `@/data/categories.categoryBySlug`. Reads categories
 * from the live repository cache (populated by the same `load()` that fetches products), so the
 * presentational cards that were synchronous stay synchronous — by the time a product card renders,
 * its section has already triggered the load, so the category is available.
 */
export function categoryBySlug(slug: string): Category | undefined {
  return productRepository.getCategoriesSync().find((c) => c.slug === slug);
}
